import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

import { decodeJWT } from '../utils/decodeToken';

import Swal from 'sweetalert2';

import moment from 'moment';

export const AuthGuard = () => {

    const token = useSelector( (state: any) => state.auth.tokenAccess);
    let sessionExpired = true;

    if( token ){

        const data = decodeJWT(token);
        const currentMoment = moment();
        const tokenExpiration = new Date(data?.exp * 1000);
        sessionExpired = moment(currentMoment).isAfter(tokenExpiration);

        if(sessionExpired){
            Swal.fire('Error', 'Tu sesión ha expirado, por favor inicia sesión nuevamente.', 'error' );
        }
        
    }

    return (token && !sessionExpired) ? <Outlet /> : <Navigate replace to={'/auth/login'} />;

};

export default AuthGuard;